import React from 'react';

import type { PageProps } from 'gatsby';

const PagePropsContext = React.createContext<PageProps | null>(null);

export const PagePropsProvider: React.FC<{ pageProps: PageProps; children: React.ReactNode }> = ({
  pageProps,
  children,
}) => <PagePropsContext.Provider value={{ ...pageProps }}>{children}</PagePropsContext.Provider>;

export const usePageProps = () => {
  const context = React.useContext(PagePropsContext);
  if (!context) throw new Error('usePageProps has to be used within a PagePropsProvider');
  return context;
};
